export default {
  metadata: {
    version: '1.0.0',
    id: 'mobile-bottom-sheet-1.0.0',
    name: 'JDSMobileBottomSheetInternal'
  },
  hierarchy: {
    container: [
      {
        'root-container': [
          {
            'cancel-container': [
              {
                'back-container': ['back-jds_action_button']
              },
              'empty-container',
              'step-jds-text',
              'cancel-jds_button'
            ]
          },
          {
            'vertical-container': [
              'title-jds-text',
              'description-jds-text',
              'children-slot',
              {
                'cta-container': [
                  'primary-jds_action_button',
                  'secondary-jds_action_button'
                ]
              }
            ]
          }
        ]
      },
      {
        'custom-container': ['children-slot']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.end}',
      'align-items': '{alignItems.end}',
      width: '{size.max}'
    },
    'root-container': {
      hidden: true,
      'z-index': 1,
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'background-color': '{primaryBackground}',
      'align-items': '{alignItems.start}',
      'border-top-left-radius': '{xl}',
      'border-top-right-radius': '{xl}',
      width: '{size.max}',
      'enter-animation-name': 'slideVerticallyUp',
      'exit-animation-name': 'slideVerticallyDown',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      'translate-y': '{size.max}',
      transition: {
        property: ['translate-y'],
        duration: '{medium}',
        'timing-function': '{easeEntrance}'
      }
    },
    'cancel-container': {
      hidden: false,
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.end}',
      'align-items': '{alignItems.center}',
      width: '{size.max}',
      'padding-top': '{xxs}',
      'padding-bottom': '{xxs}',
      'padding-left': '{xs}',
      'padding-right': '{s}',
      gap: '{s}'
    },
    'back-container': {
      flex: 1,
      hidden: true
    },
    'back-jds_action_button': {
      icon: 'ic_back',
      size: 'medium',
      kind: 'tertiary'
    },
    'empty-container': {
      flex: 1
    },
    'cancel-jds_button': {
      hidden: false,
      icon: 'ic_close',
      size: 'medium',
      kind: 'tertiary'
    },
    'vertical-container': {
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      'padding-left': '{m}',
      'padding-right': '{m}',
      width: '{size.max}'
    },
    'primary-jds_action_button': {
      hidden: false,
      kind: 'primary',
      size: 'medium',
      appearance: 'normal',
      state: 'normal',
      stretch: true
    },
    'secondary-jds_action_button': {
      hidden: false,
      kind: 'secondary',
      size: 'medium',
      appearance: 'normal',
      state: 'normal',
      stretch: true
    },
    'cta-container': {
      'flex-direction': '{flexDirection.column}',
      gap: '{base}',
      width: '{size.max}',
      'padding-bottom': '{m}',
      'padding-top': '{m}'
    },
    'children-slot': {
      'flex-fill-android': false
    },
    'custom-container': {
      hidden: true,
      'z-index': 1,
      'flex-direction': '{flexDirection.column}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      'background-color': '{primaryBackground}',
      'border-top-left-radius': '{xl}',
      'border-top-right-radius': '{xl}',
      'padding-left': '{m}',
      'padding-right': '{m}',
      'padding-top': '{m}',
      'padding-bottom': '{m}',
      width: '{size.max}',
      'translate-y': '{size.max}',
      transition: {
        property: ['translate-y'],
        duration: '{medium}',
        'timing-function': '{easeEntrance}'
      }
    },
    'step-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true,
      'padding-right': '{base}'
    },
    'title-jds-text': {
      'font-family': '{text_86}',
      color: '{text_20}',
      'font-size': '{text_85}',
      'line-height': '{text_87}',
      'letter-spacing': '{text_88}',
      'font-weight': '{text_89}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-bottom': '{xs}'
    },
    'description-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'padding-bottom': '{m}'
    }
  },
  variant: {
    kind: {
      passive: {
        'root-container': {
          'box-shadow': {
            x: 0,
            y: 4,
            blur: 16,
            spread: 0,
            color: '{custom_color_5}'
          }
        }
      }
    },
    close: {
      false: {
        'root-container': {
          'translate-y': 0,
          hidden: false
        }
      }
    },
    controlType: {
      stepper: {
        'cancel-jds_button': {
          hidden: true
        },
        'back-container': {
          hidden: false
        },
        'step-jds-text': {
          hidden: false
        }
      }
    },
    primaryCtaDisabled: {
      true: {
        'primary-jds_action_button': {
          state: 'disabled'
        }
      }
    },
    secondaryCtaDisabled: {
      true: {
        'secondary-jds_action_button': {
          state: 'disabled'
        }
      }
    },
    _noButton: {
      true: {
        'root-container': {
          'padding-bottom': '{m}'
        },
        'cta-container': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      false: {
        true: {
          'custom-container': {
            hidden: false,
            'translate-y': 0
          },
          'root-container': {
            hidden: true,
            'translate-y': '{size.max}'
          },
          'vertical-container': {
            hidden: true
          }
        }
      }
    }
  ],
  combination_config: [['close', 'isCustom']],
  api: {
    config: {
      kind: {
        values: ['overlay', 'passive']
      },
      controlType: {
        values: ['normal', 'stepper']
      },
      isCustom: {
        values: [false, true]
      },
      close: {
        values: [true, false]
      },
      primaryCtaDisabled: {
        values: [false, true]
      },
      secondaryCtaDisabled: {
        values: [false, true]
      },
      _noButton: {
        values: [false, true]
      }
    },
    data: {
      'root-container': {
        'max-height': {
          type: 'size',
          name: 'maxHeight',
          function: true
        }
      },
      'primary-jds_action_button': {
        label: {
          type: 'string',
          name: 'primaryCTA'
        }
      },
      'secondary-jds_action_button': {
        label: {
          type: 'string',
          name: 'secondaryCTA'
        }
      },
      'step-jds-text': {
        value: {
          type: 'string',
          name: 'stepLabel'
        }
      },
      'title-jds-text': {
        value: {
          type: 'string',
          name: 'title'
        }
      },
      'description-jds-text': {
        value: {
          type: 'string',
          name: 'description'
        }
      }
    },
    children: {
      'children-slot': {
        name: 'children',
        accepts: ['any'],
        max: 1
      }
    },
    events: {
      'root-container': {
        onClick: 'onBottomSheetClick',
        onSwipeDown: 'onClose'
      },
      'custom-container': {
        onClick: 'onBottomSheetClick',
        onSwipeDown: 'onClose'
      },
      'back-jds_action_button': {
        onClick: 'onBack'
      },
      'cancel-jds_button': {
        onClick: 'onCancel'
      },
      'primary-jds_action_button': {
        onClick: 'onPrimaryClick'
      },
      'secondary-jds_action_button': {
        onClick: 'onSecondaryClick'
      }
    },
    a11y: {
      'root-container': {
        properties: {
          role: {
            value: 'dialog'
          },
          'aria-label': {
            name: 'ariaLabel',
            value: 'Bottom Sheet Content'
          },
          'aria-modal': {
            name: '_ariaModal'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'cancel-jds_button': {
        properties: {
          ariaLabel: {
            name: 'cancelButtonAriaLabel',
            value: 'Close Modal'
          }
        }
      },
      'back-jds_action_button': {
        properties: {
          ariaLabel: {
            name: 'backButtonAriaLabel',
            value: 'Tap to go back'
          }
        }
      },
      'primary-jds_action_button': {
        properties: {
          ariaLabel: 'primaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'secondary-jds_action_button': {
        properties: {
          ariaLabel: 'secondaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
